// DATE — Hero champagne bubbles.
// Two sizes (7px medium, 8px large — large reduced 25% from 11px).
// Linear constant speed, travels well past the top of the viewport.

(function(){
  function init(){
    var bubbles = document.querySelectorAll('.hero-bubbles .bubble');
    if (!bubbles.length) return;

    var sizes     = [8,7,8,7,8,7,8,7,8,7,8,7,8,7,8,7,8,7,8,7,8,7,8,7,8];
    var lefts     = [3,9,18,28,38,46,55,63,72,80,87,94,13,50,76,6,15,23,32,41,48,57,66,82,90];
    var durations = [10,12,11,13,10.5,14,11.5,10,12.5,11,13,10.5,12,11,14,11.5,10,12.5,11,13,10.5,12,11.5,10.5,13];
    var delays    = [0,0.4,0.8,1.2,0.2,1.6,0.6,2.4,1,3,1.4,0.8,3.6,4,2,4.4,5,1.8,2.8,3.4,4.8,0.8,3.2,4.4,1.2];

    var container = document.querySelector('.hero-bubbles');
    if (container) {
      container.style.setProperty('position', 'absolute', 'important');
      container.style.setProperty('inset', '0', 'important');
      container.style.setProperty('z-index', '1', 'important');
      container.style.setProperty('pointer-events', 'none', 'important');
      container.style.setProperty('overflow', 'hidden', 'important');
      container.style.setProperty('display', 'block', 'important');
    }

    var BG = '#D4A574';

    bubbles.forEach(function(b, i){
      var size = sizes[i % sizes.length];
      var left = lefts[i % lefts.length];
      var duration = durations[i % durations.length];
      var delay = delays[i % delays.length];

      var s = b.style;
      s.setProperty('display', 'block', 'important');
      s.setProperty('visibility', 'visible', 'important');
      s.setProperty('position', 'absolute', 'important');
      s.setProperty('border-radius', '50%', 'important');
      s.setProperty('bottom', '-15px', 'important');
      s.setProperty('width', size + 'px', 'important');
      s.setProperty('height', size + 'px', 'important');
      s.setProperty('left', left + '%', 'important');
      s.setProperty('background', BG, 'important');
      s.setProperty('background-image', 'none', 'important');
      s.setProperty('box-shadow', 'none', 'important');
      s.setProperty('animation', 'none', 'important');
      s.setProperty('opacity', '0.85', 'important');
      s.setProperty('z-index', '1', 'important');
      s.setProperty('pointer-events', 'none', 'important');

      if (b.animate) {
        b.animate([
          { transform: 'translateY(0)',      opacity: 0,    offset: 0 },
          {                                  opacity: 0.85, offset: 0.03 },
          {                                  opacity: 0.85, offset: 0.99 },
          { transform: 'translateY(-150vh)', opacity: 0,    offset: 1 }
        ], {
          duration: duration * 1000,
          delay: delay * 1000,
          iterations: Infinity,
          easing: 'linear'
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 50);
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
